import { action } from 'satcheljs';

export interface UpdateNumDaysInDayRangeActionMessage {
    newValue: number;
    isUserChange: boolean;
}
export const updateNumDaysInDayRange: (
    newValue: number,
    isUserChange?: boolean
) => UpdateNumDaysInDayRangeActionMessage = action(
    'updateNumDaysInDayRange',
    (newValue: number, isUserChange: boolean = true): UpdateNumDaysInDayRangeActionMessage => ({
        newValue,
        isUserChange,
    })
);
